import { State } from '../../interfaces/State';
import { ChapterContentAuthorization } from '../reducers/contentAuthorization';

export const selectContentAuthorization = (
  state: State,
  chapterId: number,
): ChapterContentAuthorization | null =>
  state.get('contentAuthorization')[chapterId] || null;
